import React, { useState, useEffect } from 'react';

export default function RecordList() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLevel, setSelectedLevel] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedRecord, setSelectedRecord] = useState(null);

  const levels = ['전체', '중학생', '고등학생', '대학생', '일반인'];

  // 임시 user_id (나중에 Google OAuth로 교체)
  const user_id = 'test_user_1';

  // 기록 로드
  const loadRecords = async () => {
    setLoading(true);
    try {
      let url = `/api/learning/records?user_id=${user_id}`;
      if (selectedLevel && selectedLevel !== '전체') {
        url += `&level=${encodeURIComponent(selectedLevel)}`;
      }
      if (selectedSubject) {
        url += `&subject=${encodeURIComponent(selectedSubject)}`;
      }

      const response = await fetch(url);
      const result = await response.json();

      if (result.success) {
        setRecords(result.data);
      } else {
        console.error('Load records error:', result.error);
      }
    } catch (error) {
      console.error('Load records error:', error);
    } finally {
      setLoading(false);
    }
  };

  // 초기 로드
  useEffect(() => {
    loadRecords();
  }, [selectedLevel, selectedSubject]);

  // 복습 체크
  const handleReview = async (record) => {
    try {
      const response = await fetch('/api/learning/records', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          record_id: record.record_id,
          review_count: (record.review_count || 0) + 1
        })
      });

      const result = await response.json();

      if (result.success) {
        // 목록 갱신
        loadRecords();
        alert('복습 완료!');
      }
    } catch (error) {
      console.error('Review error:', error);
      alert('복습 체크 실패');
    }
  };

  // 마스터 토글
  const handleMaster = async (record) => {
    try {
      const response = await fetch('/api/learning/records', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          record_id: record.record_id,
          mastered: !record.mastered
        })
      });

      const result = await response.json();

      if (result.success) {
        // 목록 갱신
        loadRecords();
      }
    } catch (error) {
      console.error('Master toggle error:', error);
    }
  };

  // 삭제
  const handleDelete = async (record) => {
    if (!confirm('정말 삭제하시겠습니까?')) return;

    try {
      const response = await fetch(`/api/learning/records?record_id=${record.record_id}`, {
        method: 'DELETE'
      });

      const result = await response.json();

      if (result.success) {
        loadRecords();
        alert('삭제되었습니다');
      }
    } catch (error) {
      console.error('Delete error:', error);
      alert('삭제 실패');
    }
  };

  // 고유 과목 목록
  const subjects = ['전체', ...new Set(records.map(r => r.subject))];

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '2rem',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <h1 style={{ fontSize: '2.5rem', color: 'white', marginBottom: '2rem', textAlign: 'center' }}>
          📚 내 오답노트
        </h1>

        {/* 필터 */}
        <div style={{
          background: 'white',
          borderRadius: '1rem',
          padding: '1.5rem',
          marginBottom: '2rem',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
        }}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              레벨:
            </label>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              {levels.map(level => (
                <button
                  key={level}
                  onClick={() => setSelectedLevel(level === '전체' ? '' : level)}
                  style={{
                    padding: '0.5rem 1rem',
                    border: (selectedLevel === level || (level === '전체' && !selectedLevel))
                      ? '2px solid #667eea' : '2px solid #ddd',
                    borderRadius: '0.5rem',
                    background: (selectedLevel === level || (level === '전체' && !selectedLevel))
                      ? '#667eea' : 'white',
                    color: (selectedLevel === level || (level === '전체' && !selectedLevel))
                      ? 'white' : '#333',
                    cursor: 'pointer',
                    fontSize: '0.875rem'
                  }}
                >
                  {level}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              과목:
            </label>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              {subjects.map(subject => (
                <button
                  key={subject}
                  onClick={() => setSelectedSubject(subject === '전체' ? '' : subject)}
                  style={{
                    padding: '0.5rem 1rem',
                    border: (selectedSubject === subject || (subject === '전체' && !selectedSubject))
                      ? '2px solid #764ba2' : '2px solid #ddd',
                    borderRadius: '0.5rem',
                    background: (selectedSubject === subject || (subject === '전체' && !selectedSubject))
                      ? '#764ba2' : 'white',
                    color: (selectedSubject === subject || (subject === '전체' && !selectedSubject))
                      ? 'white' : '#333',
                    cursor: 'pointer',
                    fontSize: '0.875rem'
                  }}
                >
                  {subject}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* 로딩 */}
        {loading && (
          <div style={{ textAlign: 'center', color: 'white', fontSize: '1.2rem' }}>
            로딩 중...
          </div>
        )}

        {/* 기록 목록 */}
        {!loading && records.length === 0 && (
          <div style={{
            background: 'white',
            borderRadius: '1rem',
            padding: '3rem',
            textAlign: 'center',
            color: '#999'
          }}>
            아직 등록된 오답노트가 없습니다.
          </div>
        )}

        {!loading && records.length > 0 && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '1.5rem'
          }}>
            {records.map(record => (
              <div
                key={record.record_id}
                style={{
                  background: 'white',
                  borderRadius: '1rem',
                  padding: '1.5rem',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  border: record.mastered ? '3px solid #28a745' : '3px solid transparent'
                }}
                onClick={() => setSelectedRecord(record)}
              >
                {/* 헤더 */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '1rem'
                }}>
                  <div>
                    <span style={{
                      background: '#667eea',
                      color: 'white',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '0.25rem',
                      fontSize: '0.75rem',
                      marginRight: '0.5rem'
                    }}>
                      {record.level}
                    </span>
                    <span style={{
                      background: '#764ba2',
                      color: 'white',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '0.25rem',
                      fontSize: '0.75rem'
                    }}>
                      {record.subject}
                    </span>
                  </div>
                  {record.mastered && (
                    <span style={{ fontSize: '1.5rem' }}>✓</span>
                  )}
                </div>

                {/* 이미지 */}
                {record.image_url && (
                  <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
                    <img
                      src={record.image_url}
                      alt="문제 이미지"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '150px',
                        borderRadius: '0.5rem',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                )}

                {/* 문제 미리보기 */}
                {record.problem_text && (
                  <div style={{
                    marginBottom: '1rem',
                    fontSize: '0.875rem',
                    color: '#666',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical'
                  }}>
                    {record.problem_text}
                  </div>
                )}

                {/* 정보 */}
                <div style={{
                  fontSize: '0.75rem',
                  color: '#999',
                  marginBottom: '1rem'
                }}>
                  <div>난이도: {record.difficulty || '-'}</div>
                  <div>복습: {record.review_count || 0}회</div>
                  <div>{new Date(record.created_at).toLocaleDateString()}</div>
                </div>

                {/* 액션 버튼 */}
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReview(record);
                    }}
                    style={{
                      flex: 1,
                      padding: '0.5rem',
                      background: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '0.25rem',
                      cursor: 'pointer',
                      fontSize: '0.875rem'
                    }}
                  >
                    복습
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMaster(record);
                    }}
                    style={{
                      flex: 1,
                      padding: '0.5rem',
                      background: record.mastered ? '#ccc' : '#28a745',
                      color: 'white',
                      border: 'none',
                      borderRadius: '0.25rem',
                      cursor: 'pointer',
                      fontSize: '0.875rem'
                    }}
                  >
                    {record.mastered ? '해제' : '완료'}
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(record);
                    }}
                    style={{
                      padding: '0.5rem',
                      background: '#dc3545',
                      color: 'white',
                      border: 'none',
                      borderRadius: '0.25rem',
                      cursor: 'pointer',
                      fontSize: '0.875rem'
                    }}
                  >
                    🗑
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* 상세 모달 */}
        {selectedRecord && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '2rem',
              zIndex: 1000
            }}
            onClick={() => setSelectedRecord(null)}
          >
            <div
              style={{
                background: 'white',
                borderRadius: '1rem',
                padding: '2rem',
                maxWidth: '600px',
                maxHeight: '80vh',
                overflow: 'auto',
                width: '100%'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h2 style={{ marginBottom: '1rem' }}>오답노트 상세</h2>

              {selectedRecord.image_url && (
                <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
                  <img
                    src={selectedRecord.image_url}
                    alt="문제 이미지"
                    style={{ maxWidth: '100%', borderRadius: '0.5rem' }}
                  />
                </div>
              )}

              {selectedRecord.problem_text && (
                <div style={{ marginBottom: '1rem' }}>
                  <strong>📝 문제:</strong>
                  <div style={{
                    padding: '1rem',
                    background: '#f9f9f9',
                    borderRadius: '0.5rem',
                    marginTop: '0.5rem',
                    whiteSpace: 'pre-wrap'
                  }}>
                    {selectedRecord.problem_text}
                  </div>
                </div>
              )}

              {selectedRecord.student_answer && (
                <div style={{ marginBottom: '1rem' }}>
                  <strong>✏️ 내 답:</strong>
                  <div style={{
                    padding: '1rem',
                    background: '#ffe',
                    borderRadius: '0.5rem',
                    marginTop: '0.5rem'
                  }}>
                    {selectedRecord.student_answer}
                  </div>
                </div>
              )}

              {selectedRecord.correct_answer && (
                <div style={{ marginBottom: '1rem' }}>
                  <strong>✓ 정답:</strong>
                  <div style={{
                    padding: '1rem',
                    background: '#efe',
                    borderRadius: '0.5rem',
                    marginTop: '0.5rem'
                  }}>
                    {selectedRecord.correct_answer}
                  </div>
                </div>
              )}

              {selectedRecord.explanation && (
                <div style={{ marginBottom: '1rem' }}>
                  <strong>💡 해설:</strong>
                  <div style={{
                    padding: '1rem',
                    background: '#f9f9f9',
                    borderRadius: '0.5rem',
                    marginTop: '0.5rem',
                    whiteSpace: 'pre-wrap'
                  }}>
                    {selectedRecord.explanation}
                  </div>
                </div>
              )}

              {selectedRecord.key_concept && (
                <div style={{ marginBottom: '1rem' }}>
                  <strong>🎯 핵심 개념:</strong>
                  <div style={{
                    padding: '1rem',
                    background: '#eef',
                    borderRadius: '0.5rem',
                    marginTop: '0.5rem'
                  }}>
                    {selectedRecord.key_concept}
                  </div>
                </div>
              )}

              <button
                onClick={() => setSelectedRecord(null)}
                style={{
                  width: '100%',
                  padding: '1rem',
                  background: '#667eea',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.5rem',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  marginTop: '1rem'
                }}
              >
                닫기
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
